import React from "react";
import { T } from "../../app/tokens.js";
import { ViewKey } from "../../v2/components/ViewKey.jsx";

// Shared by the live cells and their key. History deliberately stays solid gray.
export const PRESSURE_CELL_STYLES = {
  over: { bg: T.ragRedBg, border: T.ragRedBorder, text: T.ragRed, label: "Over" },
  tight: { bg: T.ragAmberBg, border: T.ragAmberBorder, text: T.ragAmberText, label: "Tight" },
  covered: { bg: T.ragGreenBg, border: T.ragGreenBorder, text: T.ragGreenText, label: "OK" },
  attendance_unknown: { bg: T.lightGray, border: T.border, text: T.mid, label: "No data" },
  insufficient_history: { bg: T.lightGray, border: T.border, text: T.light, label: "—" },
};

const item = (verdict, label, description) => ({
  label, description,
  swatch: { kind: "cell", color: PRESSURE_CELL_STYLES[verdict].bg, border: PRESSURE_CELL_STYLES[verdict].border },
});
const GROUPS = [
  { label: "Quarter status", items: [
    item("over", "Over capacity", "assigned meets or exceeds capacity"),
    item("tight", "Tight", "90% or more, but under 100% of capacity"),
    item("covered", "Covered", "under 90% of capacity"),
  ] },
  { label: "Data", items: [
    item("attendance_unknown", "No data", "no attendance data for the market"),
    item("insufficient_history", "Under 3 months history", "trend not yet reliable"),
  ] },
];

export function PressureViewKey() {
  return <ViewKey testId="pressure-key" title="How to read this" groups={GROUPS}
    footer="Cells show assigned / capacity per quarter, using the Layer and Capacity settings in the toolbar." />;
}

function Segments({ label, id, value, options, onChange }) {
  return (
    <div role="group" aria-label={label} data-testid={`mp-${id}`}
      style={{ position: "relative", display: "inline-flex", alignItems: "center", gap: 1, padding: "10px 2px 1px", border: `1px solid ${T.border}`, borderRadius: 8, background: T.card, flexShrink: 0, whiteSpace: "nowrap" }}>
      <span style={{ position: "absolute", top: 1, left: 6, fontSize: T.fsXxxs, lineHeight: "10px", color: T.mid, fontWeight: T.fwBold, textTransform: "uppercase", letterSpacing: ".03em" }}>{label}</span>
      {options.map(([key, text]) => <button key={key} type="button" data-testid={`mp-${id}-${key}`}
        aria-pressed={value === key} onClick={() => onChange(key)}
        style={{ height: 20, padding: "0 4px", border: 0, borderRadius: 5, fontFamily: "inherit", fontSize: T.fsXs, fontWeight: T.fwSemibold, cursor: "pointer", whiteSpace: "nowrap", background: value === key ? T.blueSoft : "transparent", color: value === key ? T.blue : T.mid }}>
        {text}
      </button>)}
    </div>
  );
}

export function PressureCapacityOptions({ basis, setBasis }) {
  return <Segments label="Capacity" id="basis" value={basis} onChange={setBasis} options={[["usable", "Usable"], ["seats", "Seats"]]} />;
}

export function PressureViewOptions({ layer, basis, horizon, setLayer, setBasis, setHorizon, collapseCapacity = false }) {
  return <div data-testid="pressure-view-options" style={{ display: "flex", alignItems: "center", gap: 4, flexShrink: 0 }}>
    <Segments label="Layer" id="layer" value={layer} onChange={setLayer} options={[["as-committed", "As-committed"], ["raw", "Raw"]]} />
    {!collapseCapacity && <PressureCapacityOptions basis={basis} setBasis={setBasis} />}
    <Segments label="Horizon" id="horizon" value={horizon} onChange={setHorizon} options={[[12, "12 mo"], [18, "18 mo"], [24, "24 mo"]]} />
  </div>;
}
